import { render, staticRenderFns } from "./itsearviointi.vue?vue&type=template&id=253f21c5&scoped=true&"
import script from "./itsearviointi.vue?vue&type=script&lang=ts&"
export * from "./itsearviointi.vue?vue&type=script&lang=ts&"
import style0 from "./itsearviointi.vue?vue&type=style&index=0&id=253f21c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253f21c5",
  null
  
)

export default component.exports